import NoteConstants from 'notebook/notes/NoteConstants';
import PreviewMixin from 'notebook/notes/previews/PreviewMixin';
import createReactClass from 'create-react-class';

const SequenceAnalysisPreview = createReactClass({
  mixins: [PreviewMixin],
  className: 'note-sequence-analysis',
  noteType: NoteConstants.SEQUENCE_ANALYSIS,

  renderItem() {
    return null;
  },
});

export default SequenceAnalysisPreview;
